module.exports = __webpack_public_path__ + "img/Products_Desktop_10.60aae853.jpg";